export class CollectionDiscount {
  public discount: number;
  public collection: any;
}
